/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {type AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig} from "./helper";
import type Depot from "./Depot";
import type PaginationResponse from "./PaginationResponse";
import type PaginationRequestSearch from "./PaginationRequestSearch";
import type ReAssignRequest from "./ReAssignRequest";
import type IdName from "./IdName";

const urls = {
    index(): string {
        return "/api/depot/index";
    }
}

export default {
    urls,
    index(): Promise<AxiosResponse<Depot[]>> {
        return Axios.get("/api/depot/index", defaultConfig);
    },
    paged(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<Depot>>> {
        return Axios.post("/api/depot/paged", request, defaultConfig);
    },
    archive(request: ReAssignRequest): Promise<AxiosResponse> {
        return Axios.post("/api/depot/archive", request, defaultConfig);
    },
    upsert(request: IdName): Promise<AxiosResponse> {
        return Axios.post("/api/depot/upsert", request, defaultConfig);
    }
}
